import type { ReactNode } from 'react';
import { Image, Pressable, ScrollView, View } from 'react-native';
import { IconX } from '@tabler/icons-react-native';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useTheme } from 'app/shopify/theme';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

/** Illustration exported from the Figma artwork frame, not the sheet screenshot. */
export function GuardianAnnouncementIllustration() {
  return (
    <Image
      accessible={false}
      source={require('./assets/guardian-announcement.png')}
      style={{ width: '100%', height: 180, borderRadius: 16 }}
      resizeMode="contain"
    />
  );
}

export function FeaturePresentation({
  announcementLabel,
  closeLabel,
  title,
  description,
  illustration,
  onClose,
}: {
  announcementLabel: string;
  closeLabel: string;
  title: string;
  description: ReactNode;
  illustration: ReactNode;
  onClose: () => void;
}) {
  const theme = useTheme();
  return (
    <ScrollView
      contentContainerStyle={{
        padding: theme.spacing['spacing.general.x6'],
        width: '100%',
        alignSelf: 'center',
      }}
    >
      <Column gap="spacing.general.x4">
        <Row alignItems="center" justifyContent="space-between">
          <View style={{ width: 32 }} />
          <Text accessibilityRole="header" fontSize={20} lineHeight={24} fontWeight="700" textAlign="center" flex={1}>
            {announcementLabel}
          </Text>
          <Pressable accessibilityRole="button" accessibilityLabel={closeLabel} onPress={onClose} hitSlop={8}>
            <IconX color={theme.colors['text.primary']} size={32} strokeWidth={ICON_STROKE_WIDTH} />
          </Pressable>
        </Row>
        {illustration}
        <Text accessibilityRole="header" fontSize={20} lineHeight={24} fontWeight="700">
          {title}
        </Text>
        <Text fontSize={16} lineHeight={20}>
          {description}
        </Text>
      </Column>
    </ScrollView>
  );
}
